import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

export enum LOG_TYPE {
  error = "error",
  warn = "warn",
  info = "info",
}

export const logger = () => {
  return window.DD_LOGS ? window.DD_LOGS.logger : undefined;
};

const isSuccessfulResponse = (responseStatus: number) => {
  return responseStatus >= 200 && responseStatus < 300;
};

export const createRequestLog = (req: AxiosRequestConfig) => {
  logger() &&
    logger().info(`Request: ${req.method?.toUpperCase()} ${req.url}`, {
      request: {
        URL: req.url,
        method: req.method,
      },
    });
};

export const createResponseLog = (res: AxiosResponse) => {
  logger() &&
    logger()[isSuccessfulResponse(res.status) ? LOG_TYPE.info : LOG_TYPE.error](
      `Response: ${res.config?.method?.toUpperCase()} ${
        res.config?.url
      } Status: ${res.status}`,
      {
        response: {
          URL: res.config?.url,
          status: res.status,
          method: res.config?.method,
        },
      }
    );
};

export const createResponseErrorLog = (error: AxiosError) => {
  logger() &&
    !!error.config &&
    logger().error(
      `Response: ${error.config.method?.toUpperCase()} ${
        error.config.url
      } Status: ${error.response?.status}`,
      {
        error: {
          URL: error.config.url,
          status: error.response?.status,
          method: error.config.method,
        },
      }
    );
};
